(function(document, tag) {
    var script = document.createElement(tag);
    var element = document.getElementsByTagName('body')[0];
    script.src = 'https://acsbap.com/api/app/assets/js/acsb.js'; script.async = true; script.defer = true;
    (typeof element === 'undefined' ? document.getElementsByTagName('html')[0] : element).appendChild(script);
    script.onload = function() {
        acsbJS.init({
            statementLink     : '',
            feedbackLink      : '',
            footerHtml        : '<a href="https://WebCompliancePro.com">Website Accessibility</a>&nbsp;by&nbsp;<a href="https://WebCompliancePro.com">WebCompliancePro.com</a>',
            hideMobile        : false,
            hideTrigger       : false,
            language          : 'en',
            position          : 'left',
            leadColor         : '#054bb6',
            triggerColor      : '#146ff8',
            triggerRadius     : '50%',
            triggerPositionX  : 'left',
            triggerPositionY  : 'bottom',
            triggerIcon       : 'people',
            triggerSize       : 'medium',
            triggerOffsetX    : 20,
            triggerOffsetY    : 20,
            mobile            : {
                triggerSize       : 'small',
                triggerPositionX  : 'left',
                triggerPositionY  : 'center',
                triggerOffsetX    : 0,
                triggerOffsetY    : 0,
                triggerRadius     : '0'
            }
        });
    };
}(document, 'script'));